import { Outlet } from 'react-router-dom'

import FinancemodularroutesCollectionsBootstrap from 'modules/finance/lib/FinancemodularroutesCollectionsBootstrap'
import { FrequencyContextProvider } from 'modules/payroll_bundle/lib/frequencyContext'
import ProcurementsubmoduleCollectionsBootstrap from 'modules/procurement/lib/ProcurementsubmoduleCollectionsBootstrap'
import SoftwaremanagementsubmoduleCollectionsBootstrap from 'modules/software_management/lib/SoftwaremanagementsubmoduleCollectionsBootstrap'

import { AccountsPayableUpsellModal } from '../components/AccountsPayableUpsellModal'

const SpendingRootPage = () => {
  return (
    <FinancemodularroutesCollectionsBootstrap>
      <ProcurementsubmoduleCollectionsBootstrap>
        <SoftwaremanagementsubmoduleCollectionsBootstrap>
          <FrequencyContextProvider>
            <AccountsPayableUpsellModal source="ap_finance_upsellcard"></AccountsPayableUpsellModal>
            <Outlet />
          </FrequencyContextProvider>
        </SoftwaremanagementsubmoduleCollectionsBootstrap>
      </ProcurementsubmoduleCollectionsBootstrap>
    </FinancemodularroutesCollectionsBootstrap>
  )
}

export default SpendingRootPage
